import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={11}
      height={6}
      viewBox="0 0 11 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M5.99 5.627h0a.547.547 0 01-.76 0h.76zm0 0l4.05-3.922h0a.52.52 0 00-.001-.753h0a.549.549 0 00-.76.001h0L5.61 4.508 1.94.953h0a.549.549 0 00-.758-.001h0a.522.522 0 00-.001.753h0l4.05 3.922h.76z"
        fill="#E40046"
        stroke="#E40046"
        strokeWidth={0.4}
      />
    </Svg>
  );
}

export default SvgComponent;
